import axios from "axios";
import {DateTime as dt} from 'luxon'

const meta = (context) => ({
    uuid: context.rootState.meta.uuid,
    conversationId: context.rootState.meta.conversationId,
});

export default {
    _fetchCache(context) {
        return (
            axios
                .get("api/retrieve-all", { params: { ...meta(context) } })
                .then((response) => response.data.data)
                .then((response) => {

                    const i = response.internet,
                        t = response.tv,
                        v = response.voice,
                        f = response.install;

                    const getSpeed = (serviceName, defaultSpeed) => {
                        if (
                            context.rootState.meta.marketType === "fiber-competitive"
                        ) {
                            return {
                                fiberCore: {
                                    download: 100,
                                    upload: 100,
                                },
                                fiberFast: {
                                    download: 200,
                                    upload: 200,
                                },
                                fiberUltraFast: {
                                    download: 500,
                                    upload: 500,
                                },
                                fiberGigaFast: {
                                    download: 1000,
                                    upload: 600,
                                },
                            }[serviceName];
                        } else if (
                            context.rootState.meta.marketType ===
                            "fiber-competitive-equal-speed"
                        ) {
                            return {
                                fiberCore: {
                                    download: 100,
                                    upload: 100,
                                },
                                fiberFast: {
                                    download: 200,
                                    upload: 200,
                                },
                                fiberUltraFast: {
                                    download: 500,
                                    upload: 500,
                                },
                                fiberGigaFast: {
                                    download: 1000,
                                    upload: 1000,
                                },
                            }[serviceName];
                        } else {
                            return {
                                download: defaultSpeed,
                                upload: defaultSpeed,
                            };
                        }
                    };

                    // const getCredits = (serviceName) => {
                    //     const ic = i.credits;
                    //     const fmf = ic.length >= 2 && ic[0].price === -5.00 && ic[1].price === -10.00
                    //
                    //     if(!fmf) return 0
                    //
                    //     return ic.length
                    //         ? {
                    //               baseInternet: { price: 0 },
                    //               unlimitedFast: ic[0],
                    //               unlimitedFiberFast: ic[0],
                    //               unlimitedSuperFast: ic[0],
                    //               unlimitedUltraFast: ic[1],
                    //               unlimitedFiberUltraFast: ic[1],
                    //               unlimitedGigaFast: ic[1],
                    //               unlimitedFiberGigaFast: ic[1],
                    //           }[serviceName].price || 0
                    //         : 0;
                    // };

                    return {
                        internet: {
                            services: {
                                core: {
                                    isVisible: false,
                                    title: "Core",
                                    keyPoints: [
                                        "Web Browsing",
                                        "Unlimited data usage",
                                    ],
                                    idealFor: "Up to 3 devices",
                                    icon: "speed-wifi-1.svg",
                                    promoDuration: 6,
                                    speed: getSpeed("core", 100),
                                    ...i.services.core,

                                    // credit: getCredits("core"),
                                },
                                fast: {
                                    isVisible: false,
                                    title: "Fast",
                                    keyPoints: [
                                        "Web Browsing",
                                        "Basic Streaming",
                                        "Unlimited data usage",
                                    ],
                                    idealFor: "Up to 6 devices",
                                    icon: "speed-wifi-2.svg",
                                    promoDuration: 6,
                                    speed: getSpeed("fast", 200),
                                    ...i.services.fast,

                                    // credit: getCredits("fast"),
                                },
                                fiberCore: {
                                    isVisible: false,
                                    title: "Fiber Core",
                                    keyPoints: [
                                        "Web Browsing",
                                        "Basic Streaming",
                                        "Unlimited data usage",
                                    ],
                                    idealFor: "Up to 6 devices",
                                    icon: "speed-wifi-2.svg",
                                    promoDuration: 6,
                                    speed: getSpeed("fiberCore", 100),
                                    ...i.services.fiberCore,

                                    // credit: getCredits("fiberFast"),
                                },
                                fiberFast: {
                                    isVisible: false,
                                    title: "Fiber Fast",
                                    keyPoints: [
                                        "Web Browsing",
                                        "Basic Streaming",
                                        "Unlimited data usage",
                                    ],
                                    idealFor: "Up to 6 devices",
                                    icon: "speed-wifi-2.svg",
                                    promoDuration: 6,
                                    speed: getSpeed("fiberFast", 200),
                                    ...i.services.fiberFast,

                                    // credit: getCredits("fiberFast"),
                                },
                                superFast: {
                                    isVisible: false,
                                    title: "SuperFast",
                                    keyPoints: [
                                        "Web Browsing",
                                        "Moderate Streaming",
                                        "Unlimited data usage",
                                    ],
                                    idealFor: "Up to 7 devices",
                                    icon: "speed-wifi-3.svg",
                                    promoDuration: 6,
                                    speed: getSpeed("superFast", 250),
                                    ...i.services.superFast,

                                    // credit: getCredits("superFast"),
                                },
                                ultraFast: {
                                    isVisible: false,
                                    title: "UltraFast",
                                    keyPoints: [
                                        "Web Browsing",
                                        "Moderate Streaming",
                                        "Online gaming",
                                        "Unlimited data usage",
                                    ],
                                    idealFor: "Up to 11 devices",
                                    icon: "speed-wifi-3.svg",
                                    promoDuration: 6,
                                    speed: getSpeed("ultraFast", 500),
                                    ...i.services.ultraFast,

                                    // credit: getCredits("ultraFast"),
                                },
                                fiberUltraFast: {
                                    isVisible: false,
                                    title: "Fiber UltraFast",
                                    keyPoints: [
                                        "Web Browsing",
                                        "Moderate Streaming",
                                        "Online gaming",
                                        "Unlimited data usage",
                                    ],
                                    idealFor: "Up to 11 devices",
                                    icon: "speed-wifi-3.svg",
                                    promoDuration: 6,
                                    speed: getSpeed(
                                        "fiberUltraFast",
                                        500
                                    ),
                                    ...i.services.fiberUltraFast,

                                    // credit: getCredits("fiberUltraFast"),
                                },
                                gigaFast: {
                                    isVisible: false,
                                    title: "GigaFast",
                                    keyPoints: [
                                        "High-Speed downloads",
                                        "Fast streaming",
                                        "Competitive online gaming",
                                        "Unlimited data usage",
                                    ],
                                    idealFor: "12+ devices",
                                    icon: "speed-wifi-4.svg",
                                    promoDuration: 6,
                                    speed: getSpeed("gigaFast", 1000),
                                    ...i.services.gigaFast,

                                    // credit: getCredits("gigaFast"),
                                },
                                fiberGigaFast: {
                                    isVisible: false,
                                    title: "Fiber GigaFast",
                                    keyPoints: [
                                        "High-Speed downloads",
                                        "Fast streaming",
                                        "Competitive online gaming",
                                        "Unlimited data usage",
                                    ],
                                    idealFor: "12+ devices",
                                    icon: "speed-wifi-4.svg",
                                    promoDuration: 6,
                                    speed: getSpeed(
                                        "fiberGigaFast",
                                        1000
                                    ),
                                    ...i.services.fiberGigaFast,

                                    // credit: getCredits("fiberGigaFast"),
                                },
                            },
                            equipments: {
                                modemOptions: {
                                    noModem: {
                                        ...i.equipments.noModem,
                                        isVisible:
                                            i.equipments.noModem &&
                                            !i.services.fiberFast
                                                ? i.equipments.noModem.isVisible
                                                : false,
                                    },
                                    modemOnly: {
                                        ...i.equipments.onlyModem,
                                        isVisible:
                                            i.equipments.onlyModem &&
                                            !i.services.fiberFast
                                                ? i.equipments.onlyModem
                                                    .isVisible
                                                : false,
                                    },
                                    modemOnlyWithDiscount: {
                                        ...i.equipments.onlyModemWithDiscount,
                                        isVisible:
                                            i.equipments.onlyModemWithDiscount
                                                ? i.equipments.onlyModemWithDiscount
                                                    .isVisible
                                                : false,
                                    },
                                },
                                wywOptions: {
                                    modemWithOnePod: {
                                        ...i.equipments2?.modemWithOnePod,
                                        ...i.equipments?.modemWithOnePod,
                                        isVisible: (i.equipments2?.modemWithOnePod || i.equipments?.modemWithOnePod) && !i.services.fiberFast ? (i.equipments2?.modemWithOnePod?.isVisible || i.equipments?.modemWithOnePod?.isVisible): false,
                                    },
                                    modemWithTwoPods: {
                                        ...i.equipments2.modemWithTwoPods,
                                        isVisible:
                                            i.equipments2.modemWithTwoPods &&
                                            !i.services.fiberFast
                                                ? i.equipments2.modemWithTwoPods
                                                    .isVisible
                                                : false,
                                    },
                                    fiberModem: {
                                        ...i.equipments2?.modemWithOnePod,
                                        ...i.equipments2.modemWithTwoPods,
                                        isVisible: i.services.fiberFast
                                            ? i.services.fiberFast
                                                .isVisible
                                            : false,
                                    },
                                },
                                podsAndExtenders: i.podsAndExtenders,
                            },
                        },

                        tv: {
                            iptvServices: t.iptvServices || {},
                            iptvEquipments: t.iptvEquipments || {},
                            tivoServices: t.tivoServices || {},
                            tivoEquipments: t.tivoEquipments || {},
                            streamingServices: t.streamingServices,
                            packages: {
                                localsPlus: t.basePackageWithCredits.localsPlus,
                                varietyPlus: t.channels.varietyPlus,
                                familyPlus: t.channels.familyPlus,
                            },
                            premiumChannels: Object.keys(t.channels)
                                .filter(
                                    (key) =>
                                        t.channels[key].category === "premium"
                                )
                                .map((key) => t.channels[key]),
                            internationalChannels: Object.keys(t.channels)
                                .filter(
                                    (key) =>
                                        t.channels[key].category ===
                                        "international"
                                )
                                .map((key) => t.channels[key]),
                            credits: [
                                t.basePackageWithCredits.internetTVCredit,
                            ],
                        },
                        voice: {
                            services: {
                                unlimitedPhone:
                                    v.services.unlimitedVoiceService ||
                                    v.services.unlimitedPhone ||
                                    null,
                                phoneInterest: v.services.phoneInterest || null,
                            },
                            portOptions: {
                                port: {
                                    ...v.services.portPhoneNumber,
                                    altName: "Port/Keep Phone Number",
                                },
                                host: {
                                    ...v.services.hostPhoneNumber,
                                    altName: "Host/New Phone Number",
                                },
                            },
                            credits: [v.services["internet+PhoneDiscount"]],
                        },
                        install: {
                            ...f.options,
                        },
                    };
                })
        );
    },

    _fetchCart(context) {
        return (
            axios.get("api/receipts", { params: { ...meta(context) } })
                .then((response) =>
                    context.dispatch("_formatCartData", response.data.data.receipt)
                )
        );
    },

    _fetchTaxes(context) { // this Call pulls the estimated taxes from the customer's future statement
        return axios.get("api/future-statement", { params: { ...meta(context), statementNumber: 2 }
        }).then((response) => {
            return response?.data?.data
        }).catch(() => {
            return 0 // if there is an error, return 0
        })
    },

    _futureStatement(context, data) { // this Call pulls the estimated taxes from the customer's future statement
        return axios.post("api/future-statement",  { ...meta(context), accountNumber: data.accountNumber, statementNumber: 2 }
        ).then((response) => {
            return response?.data?.data
        }).catch(() => {
            return 0 // if there is an error, return 0
        })
    },

    _fetchDropStatus(context) {
        // If we're using CSG Prod, we want to use production API.
        let dropStatusUrl = "https://api.breezeline.com/api/v1/slbos/drop-status";

        // If SCTE, use relative url based on apiUrl
        if (context.rootState.csgEnvironment !== 'PROD') {
            dropStatusUrl = "api/v1/slbos/drop-status";
        }

        return axios.get(dropStatusUrl, {
                params: {
                    ...meta(context),
                    LocationId: context.rootState.meta.locationId,
                },
            }
        );
    },

    _formatCartData(context, data) {
        const r = data,
            serviceParser = (serviceType) =>
                r.service[serviceType].map((s) => ({
                    name: s.name,
                    promoPrice: s.promo_rate,
                })),
            addOnsParser = (serviceType) => {
                const addOns  = r.add_ons[serviceType] || {},
                    results = {};

                for (const key in addOns) {
                    results[key] = addOns[key].map((item) => ({
                        name: item.name,
                        quantity: item.quantity,
                        promoPrice: item.promo_rate,
                    }));
                }

                return results;
            };
        let cartData = {
            services: {
                title: `Internet${r.service.video.length ? " + TV" : ""}${r.service.phone.length ? " + Home Phone" : ""}`,
                subtotal: r.service_subtotal - context.state.internet.mobileDiscountAmount, // Subtract the discount
                internet: serviceParser("internet"),
                tv: serviceParser("video"),
                voice: serviceParser("phone"),
            },
            addOns: {
                subtotal: r.equipment_and_upgrades_subtotal,
                internet: addOnsParser("internet"),
                tv: addOnsParser("video"),
                voice: addOnsParser("phone"),
                installation: addOnsParser("install"),
                promo: addOnsParser('promo'),
            },
            promoPriceTotal: r.promo_rate,
            firstMonthTotal: r.total_charges,
            fullPriceTotal: r.subscription_rate,
        }

        return {...cartData, taxes: context.state.receipt.cartData?.taxes ?? 0}
    },

    _setSessionStatus(context, { session_status, mobile_eligible, mobile_interested, label_data }) {
        return axios.post("api/session-status", {
            ...meta(context),
            session_status,
            mobile_eligible,
            mobile_interested,
            label_data
        });
    },

    _tv_fetchChannelLineup(context) {
        return axios.get("api/channel-lineup", {
            params: {
                zipcode: String(context.rootState.meta.postalCode).slice(0, 5),
            },
        })
            .then((response) => {
                return response.data.data;
            });
    },

    _all_updateDecisions(context, decisions) {
        console.log('_all_updateDecisions: ', JSON.stringify(decisions, null, 2))
        return axios.post("api/update-decisions", {
            ...meta(context),
            decisions,
        },{
            cancelToken: context.rootState.Buyflow.source.token
        });
    },

    _all_collectDecisions(context) {
        return axios.get("api/update-decisions", {
            params: {
                ...meta(context),
            }
        });
    },

    _fetchCustomerInformation(context) {
        const metaData = meta(context);
        return axios.get("api/customer-informations", {
            params: { ...metaData },
        });
    },

    _checkout_submitCustomerInformation(
        context,
        {
            firstName,
            lastName,
            phoneNumber,
            emailAddress,
            line1,
            line2,
            city,
            stateOrProvince,
            postalCode,
            sameAddress,
            referralCode,
        }
    ) {
        return axios.post("api/customer-informations", {
            ...meta(context),
            firstName,
            lastName,
            phoneNumber,
            emailAddress,
            referralCode,
            billingDetails: {
                firstName,
                lastName,
                line1: line1 || context.rootState.meta.line1,
                line2: line2 || context.rootState.meta.line2,
                city: city || context.rootState.meta.city,
                stateOrProvince: stateOrProvince || context.rootState.meta.stateOrProvince,
                postalCode: postalCode || context.rootState.meta.postalCode.substring(0, 5),
                sameAddress: sameAddress
            },
        });
    },

    _fetchSchedulerTimes(context, { startingDate = dt.now().toFormat('yyyy-LL-dd') }) {
        return axios.get("api/schedule-installations", {
            params: { ...meta(context), startingDate },
        });
    },

    _checkout_submitScheduleInstall(context, { date, timeSlot }) {
        return axios.post("api/schedule-installations", {
            ...meta(context),
            date,
            timeSlot,
        });
    },

    _checkout_completeOrder(context, payload) {
        let sessionTest = window?.sessionTest || 'original'
        let ohioTest = context.rootState?.meta?.ohioTest || ''
        let combinedTest = sessionTest
        let appliedPromotions = context.rootState?.Promotions?.appliedPromotions || {}

        const key = Object.keys(appliedPromotions).length > 0 ? Object.keys(appliedPromotions)[0] : "not available";

        if (ohioTest) {
            combinedTest += ` ${ohioTest}`
        }

        return axios.post("api/order-summaries", {
            ...meta(context),
            isPendingDisconnect: false,
            sessionTest: combinedTest,
            promotion: key,
            ...payload,
        });
    },

    _fetchKeycloakPublicKey() {
        return axios.get("api/keycloak/initiate")
            .then((response) => {
                return response?.data?.public_key_pem?.replace('\n', '');
            });
    },

    _addGiftCard (context) {
        return axios.post("api/gc1-decision", {
            ...meta(context),
            selected: {
                name: "Gift Card"
            },
        });
    }
};
